// ============================================================================
// page-service / work-with-us.js
// ----------------------------------------------------------------------------
// Adds `--reverse` to every other card so the layout alternates image-left /
// image-right down the section. Indices 1, 3, 5… get the modifier (matches
// the original inline `index % 2 === 1` check).
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".services-work-with-us__card-item");
  cards.forEach(function (el, index) {
    if (index % 2 === 1) {
      el.classList.add("services-work-with-us__card-item--reverse");
    }
  });
});
